/**
 * Step, Colour aliases (Phase 65 / BLU-594 PR4). Optional. Embeds the bare
 * ColourCodesSection (no Card of its own) in a bordered container. The step
 * can be skipped (the bridge's built-in codes cover the common cases, so a
 * store whose codes already match can move on); Skip and Undo skip live in
 * the pane footer, supplied by the page through the step chrome and saved on
 * the server (D13). A skipped step shows its note in the grey saved box.
 */
import { useTranslation } from 'react-i18next';
import { ColourCodesSection } from '@/features/production-settings/components/ColourCodesSection';
import { StepPane } from '../shell/StepPane';

interface Step4Props {
  skipped: boolean;
  rows: number;
}

export function Step4ColourAliases({ skipped, rows }: Step4Props) {
  const { t } = useTranslation('onboarding');

  return (
    <StepPane
      title={t('step4.title')}
      description={t('step4.description')}
      summary={skipped ? t('step4.skippedNote') : t('step4.summary', { count: rows })}
    >
      <div className="rounded-lg border p-4">
        <ColourCodesSection />
      </div>
    </StepPane>
  );
}
